import { createTextNodes } from '../utils/create-text-nodes';
export var paragraph = function paragraph() {
  for (var _len = arguments.length, content = new Array(_len), _key = 0; _key < _len; _key++) {
    content[_key] = arguments[_key];
  }
  return {
    type: 'paragraph',
    content: createTextNodes(content)
  };
};